import {
  ADD,
  REMOVE,
  REMOVE_AFTER_DELAY,
  SHOW,
} from 'modules/Notifications/types'

export const notificationShow = (props) => ({
  type: SHOW,
  payload: props,
})

export const notificationAdd = (props) => ({
  type: ADD,
  payload: props,
})

export const notificationRemoveAfterDelay = (props) => ({
  type: REMOVE_AFTER_DELAY,
  payload: props,
})

export const notificationRemove = (props) => ({
  type: REMOVE,
  payload: props,
})
